import ReferenceData from "../../constants/ReferenceData";
import { executePost, executePostWithAuth, executeGet } from "../../utils/appUtils";

// clone AuthenticationStatusService.getAuthData
export const getAuthData = () => {
    const getAuthDataSuccess = (results) => {
        if (results && results.data) {
            return results.data;
        }
    };

    const liveUrl = __baseApiUrl__ + ReferenceData.GET_AUTH_DATA;
    const payload = {};

    return executePost(liveUrl, "getAuthDataFault", payload)
        .then(getAuthDataSuccess)
        .catch((err) => {
            console.log("getAuthData Error: ", err);
            throw err;
        });
};

export const callAuthenticate = (fp) => {
    const callAuthenticateSuccess = (results) => {
        if (results && results.data) {
            return results.data;
        }
    };

    const liveUrl = __baseApiUrl__ + ReferenceData.CALL_AUTHENTICATE;
    const payload = fp;

    return executePostWithAuth(liveUrl, "callAuthenticateFault", payload)
        .then(callAuthenticateSuccess)
        .catch((err) => {
            console.log("callAuthenticate Error: ", err);
            throw err;
        });
};

export const getDefaultCustomizationRetr = () => {
    const getDefaultCustomizationRetrSuccess = (results) => {
        if (results && results.data) {
            return results.data;
        }
    };

    const liveUrl = __styleEnv__ + ReferenceData.GET_DEFAULT_CUSTOMIZATION;
    const payload = {};

    return executeGet(liveUrl, "getDefaultCustomizationRetrFault", payload)
        .then(getDefaultCustomizationRetrSuccess)
        .catch((err) => {
            console.log("getDefaultCustomizationRetr Error: ", err);
            throw err;
        });
};
